/* eslint-disable no-shadow */
import React, { useContext } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { useLocation } from 'react-router-dom';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { AccountContext } from '../../../components/AccountContext';
import { parse, filterPaginationWithSize } from '../../../utils/UrlUtil';
import { VIEWER_LOCALE } from '../../../components/Query';
import CreditPlanForm from './CreditPlanForm';

const NEW_CREDIT_PLAN_QUERY = gql`
  query NewCreditPlanQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      canTransferToInOrganisation {
        id
        displayName
        creditPlan
        numberOfInternalRespondents
        unlimitedCreditPlanExpirationDate
      }
    }
  }
`;

const UPDATE_CREDIT_PLAN_MUTATION = gql`
  mutation UpdateCreditPlan($input: UpdateAccountCreditPlanInput!) {
    updateAccountCreditPlan(input: $input) {
      account {
        id
      }
    }
  }
`;

const CreditPlansQuery = () => {
  const location = useLocation();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };

  return (
    <Query query={VIEWER_LOCALE}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        return (
          <Query query={NEW_CREDIT_PLAN_QUERY} variables={variables}>
            {({ data, loading, error }) => {
              if (error) {
                return (
                  <p>
                    ERROR:
                    {JSON.stringify(error)}
                  </p>
                );
              }
              if (loading) return <p>Loading...</p>;

              const accounts = data && data.account ? data.account.canTransferToInOrganisation : [];

              return (
                <Mutation mutation={UPDATE_CREDIT_PLAN_MUTATION}>
                  {(updateCreditPlan) => (
                    <CreditPlanForm
                      accounts={accounts}
                      updateCreditPlanMutation={updateCreditPlan}
                    />
                  )}
                </Mutation>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

export default CreditPlansQuery;
